export default __webpack_public_path__ + "static/media/Tesvik_Tanimlama_Ornek.5ba596c4.xlsx";